import { useTranslation } from "react-i18next";

const ChangeBtn = ({ onHandleClick }) => {
    const [t] = useTranslation("global");
    return (
        <button
            className="account-edit-btn ocean-blanc-btn"
            onClick={() => onHandleClick()}
        >
            <div className="edit-svg ocean-svg"></div>
            <span>{t("account.change")}</span>
        </button>
    );
};

export default ChangeBtn;
